import React from 'react';
import { Box, Chip } from '@mui/material';

const TagsCell = ({ row }) => {
  const tags = row.tags;
  
  // group이 없는 경우 빈 문자열 반환
  if (!tags) return '-';
  
  return (
    <div style={{ display: 'inline-flex', gap: 4, justifyContent: 'center', alignItems: 'center' }}>
      {tags.map((tag, index) => (
        <Chip
          key={index}
          label={tag}
          size="small"
          variant="outlined"
          color="primary"
        />
      ))}
    </div>
  );
};

export default TagsCell;
